import { Button } from '@/components/Button.tsx'
import { IconArrowBack } from '@tabler/icons-react'

interface PhotoCropBottomActionsProps {
  onBack: () => void
  onContinue: () => void
  isProcessing: boolean
  disabled: boolean
  continueText: string
  totalCount: number
}

export function PhotoCropBottomActions({
  onBack,
  onContinue,
  isProcessing,
  disabled,
  continueText,
  totalCount
}: PhotoCropBottomActionsProps) {
  return (
    <div className='fixed bottom-0 left-0 w-full z-50 bg-secondary border-t-4 border-primary shadow-lg'>
      <div className='container px-4 mx-auto py-3 flex items-center justify-between flex-row h-[4rem]'>
        <div className='flex-1 flex justify-start'>
          <Button
            color="primary"
            variant="outline"
            size="sm"
            onClick={onBack}
          >
            <IconArrowBack size={16} />
            Zurück
          </Button>
        </div>
        <div className='flex-1 flex justify-center items-center text-center font-semibold leading-5 text-primary'>
          {/* Empty center space */}
        </div>
        <div className='flex-1 flex justify-end'>
          <Button
            color="primary"
            size="sm"
            disabled={disabled}
            loading={isProcessing}
            onClick={onContinue}
          >
            {continueText} ({totalCount})
          </Button>
        </div>
      </div>
    </div>
  )
}
